export const AlphabeticalSorter = (data) => {
  let sortedList = data.sort((a, b) => a.value.localeCompare(b.value))
  return sortedList
}
